<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    > 
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" :options.sync="options" :server-items-length="totalDesserts" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Cufd's </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <!-- <template v-slot:[`item.opciones`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template> -->
      </v-data-table>
    </template>

    <PuntoReg ref="puntoreg" v-on:newregcufd="newregcufd" />
  </div>
</template>

<script>
  import PuntoReg from '@/views/recibos/cufds/registrar.vue';
  import { getAccessToken } from '@/accessToken';
  import xaxios from '@/xaxios';
  import axios from 'axios';

  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      options: {},
      totalDesserts: 0,
      headers: [
        { text: 'codigo Control', value: 'codigoControl' },
        { text: 'codigo', value: 'codigo' },
        { text: 'estado', value: 'estado' },
        { text: 'Fecha Vencimiento', value: 'xfecha' },
        { text: 'Opciones', value: 'opciones', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      apikeytoken: null,
    }),

    components: { PuntoReg },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
      options: {
        handler() {
          window.console.log('options', this.options);
          this.initialize();
        },
        deep: true,
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      async initialize() {
        let vue = this;
        let codsucursal = this.$route.query.codsucursal;
        let codigopunto = this.$route.query.codigopunto;
        vue.loading = true;
        vue.desserts = [];
        let page = this.options.page;
        if (!page) page = 0;
        else page -= 1;

        await this.obtenerToknFactura();
        var config = {
          method: 'get',
          //url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas`,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cufds/${codsucursal}/${codigopunto}?size=10&page=${page}`,
          headers: {
            apikey: this.apikeytoken,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            //window.console.log('data:', data);
            //data.content.reverse();
            data.content.map((x) => {
              x.xfecha = vue.parseFecha(x.fecha);
            });
            vue.totalDesserts = data.totalElements;
            vue.desserts = data.content;
            vue.loading = false;
            //window.console.log(vue.desserts);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregcufd(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.codigo = item.codigo;
          e.codigoControl = item.codigoControl;
          e.estado = item.estado;
          e.fecha = item.fecha;
          e.puntoVentaId = item.puntoVentaId;
          e.sucursalId = item.sucursalId;
        } else {
          //this.desserts.unshift(item);
          this.initialize();
        }
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        let codigopunto = this.$route.query.codigopunto;
        let numsucursal = this.$route.query.codsucursal;
        this.$refs.puntoreg.openmodal(item, codigopunto, numsucursal);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      parseFecha(f) {
        if (!f) return '';
        let fs = f.split('T');
        let tz = fs[1].split('.');
        return `${fs[0]} ${tz[0]}`;
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      async obtenerToknFactura() {
        let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
    },
  };
</script>
